import {
  ApiResponse,
  SiteVisitList,
  TokenData,
  Participant,
  SiteVisitScheduleDetails,
  ScheduleSiteVisitData,
  LandLord,
} from "../models";
import * as http from "./http";
import ApiService from "./service";
export class SiteVisitService extends ApiService {
  public async getParticipants(id?: string) {
    const url = `${this.apiDomain}/api/company/peoples/${id}`;

    const resposne = await http.get<ApiResponse<Participant[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async getAllSiteVisit(id: string) {
    const url = `${this.apiDomain}/api/siteVisit/siteVisit/${id}`;
    const resposne = await http.get<
      ApiResponse<{ siteVisitProperties: any[]; siteVisits: any[] }>
    >(url, this.store);
    return resposne?.data?.data;
  }

  public async createSiteVisit(data: any, id?: string) {
    const url = `${this.apiDomain}/api/siteVisit`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  public async updateSiteVisit(data: any, id?: string) {
    const url = `${this.apiDomain}/api/siteVisit/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createSiteVisitSummary(data: any, id?: string) {
    const url = `${this.apiDomain}/api/siteVisit/summary/${id}`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async scheduleSiteVisit(id?: string) {
    const url = `${this.apiDomain}/api/siteVisit/${id}`;
    const response = await http.post<ApiResponse<any>>(url, this.store);
    return response.data;
  }

  public async getSiteVisit(id?: string,  subId?: string) {
    const url = `${this.apiDomain}/api/siteVisit/detail/${id}`;
    const resposne = await http.get<ApiResponse<any>>(url, this.store);
    
    if(subId){
      const updatedResponse = resposne?.data?.data

      return ({ 
        ...updatedResponse, 
        propertyIds: updatedResponse?.propertyIds?.filter((propertyId:any)=>propertyId=== subId), 
        propertyDetails:  updatedResponse?.propertyDetails?.filter((propertyDetails:any)=>propertyDetails?._id  === subId) })
    }else{
      return resposne?.data?.data;
    }
  }

  public async schedule(id?: string, data?: ScheduleSiteVisitData) {
    const url = `${this.apiDomain}/api/siteVisit/schedule/${id}`;
    const resposne = await http.post<ApiResponse<any[]>>(url, data, this.store);
    return resposne?.data;
  }

  public async reSchedule(id?: string, data?: SiteVisitScheduleDetails) {
    const url = `${this.apiDomain}/api/siteVisit/re-schedule/${id}`;
    const resposne = await http.post<ApiResponse<any[]>>(url, data, this.store);
    return resposne?.data;
  }

  public async getLandLords(id?: string, type?: string) {
    const url = `${this.apiDomain}/api/property/landlords/${id}`;
    const resposne = await http.get<ApiResponse<LandLord[]>>(url, this.store);
    if (type) {
      return resposne?.data?.data ? resposne?.data?.data : [];
    }
    return resposne?.data?.data;
  }

  public async addNewLandLord(id: string, data: any) {
    const url = `${this.apiDomain}/api/property/add/landlord/${id}`;
    const response = await http.post<ApiResponse<any[]>>(url, data, this.store);
    return response?.data?.data;
  }

  async downloadSiteVisitSummaryPdf(siteVisitId: string, title?: string) {
    const url = `${this.apiDomain}/api/siteVisit/download-pdf/${siteVisitId}`;
    const reponse = await http.downloadPostData(
      url,
      { siteVisitId },
      this.store
    );
    http.saveDownloadedFile(
      reponse.data,
      "application/pdf",
      `${title || "Site visit summary"}.pdf`
    );
    return;
  }

  public async sendSiteVisitSummaryEmail(siteVisitId: string) {
    const url = `${this.apiDomain}/api/siteVisit/send-site-visit-summary-email/${siteVisitId}`;

    const response = await http.post<ApiResponse<any>>(
      url,
      { siteVisitId },
      this.store
    );
    return response.data;
  }
}
